import { useMemo } from 'react';

import { useConsigneeAccountInfo } from './useConsigneeAccountInfo';

export function useConsigneeAccountDisplayName(sellerAccountId: string | null) {
  const { data: consigneeAccountInfo } = useConsigneeAccountInfo();

  const accountName = useMemo(() => {
    if (sellerAccountId == null) {
      return null;
    }

    return (
      consigneeAccountInfo?.find((account) => account.id === sellerAccountId)
        ?.accountName || null
    );
  }, [consigneeAccountInfo, sellerAccountId]);

  return {
    accountName,
  };
}
